import { defineStore } from 'pinia';

type UserRole = 'doctor' | 'clinic_doctor' | 'admin' | null;

interface UserState {
  role: UserRole;
  token: string | null;
}

export const useUserStore = defineStore('user', {
  state: (): UserState => ({
    role: null,
    token: null,
  }),

  getters: {
    isAuthenticated: (state): boolean => !!state.token,
  },

  actions: {
    setUser({ role, token }: { role: UserRole; token: string | null }) {
      this.role = role;
      this.token = token;

      if (typeof localStorage !== 'undefined') {
        if (role) {
          localStorage.setItem('role', role);
        } else {
          localStorage.removeItem('role');
        }

        if (token) {
          localStorage.setItem('token', token);
        } else {
          localStorage.removeItem('token');
        }
      }
    },

    loadFromStorage() {
      if (typeof localStorage === 'undefined') {
        return;
      }

      const savedRole = localStorage.getItem('role');
      const token = localStorage.getItem('token');

      this.role = savedRole === 'doctor' || savedRole === 'clinic_doctor' ? savedRole : null;
      this.token = token || null;
    },

    logout() {
      this.role = null;
      this.token = null;

      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem('role');
        localStorage.removeItem('token');
      }
    },
  },
});
